import type { OptionsMap } from '@openx/types/options';

type ReducedOptions = {
  mapById: OptionsMap;
  options: string[];
};

export type OptionByPath = {
  id: string;
  name: string;
  path: string;
  filter: Record<string, unknown>;
  extra: Record<string, unknown>;
} | null;

export const reduceOptionsByPath = (optionsByPath?: OptionByPath[]): ReducedOptions => {
  if (!optionsByPath) {
    return { mapById: {}, options: [] };
  }

  return optionsByPath.reduce<ReducedOptions>(
    (acc, option) => {
      if (!option?.name || !option?.id) {
        return acc;
      }

      const { id, name } = option;

      acc.options.push(id);
      acc.mapById[id] = {
        id,
        name,
      };

      return acc;
    },
    { mapById: {}, options: [] }
  );
};
